<template>
  <div id="app">
    <top-nav v-bind:pages="pages"/>
    <router-view/>
  </div>
</template>

<script>
import TopNav from '@/components/top-nav'

export default {
  name: 'App',
  props: [ 'pages' ],
  components: {
    TopNav
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0;
}

.wrapper {
  max-width: 900px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue